import {
    type GetUploadTokenForProfilePhotoResponseType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForProfilePhoto = async (): Promise<GetUploadTokenForProfilePhotoResponseType> => {
    return await request<GetUploadTokenForProfilePhotoResponseType>("/auth/getUploadTokenForProfilePhoto", {
        method: "GET"
    });
};

export default GetUploadTokenForProfilePhoto;
